import { createApiClient } from '@repo/api-client'

const PRODUCTION_API_URL = 'https://api.clicketpro.fr'

const isLocalDevHost = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'

/** App web en prod : API via /api sur la même origine (nginx → Next.js). */
const isSameOriginApiHost = (hostname) =>
  hostname === 'app.clicketpro.fr' ||
  (process.env.NODE_ENV !== 'production' && isLocalDevHost(hostname))

export const resolveApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location

    if (isSameOriginApiHost(hostname)) {
      return ''
    }
  }

  const configured = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '')
  if (configured) return configured

  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location
    if (isLocalDevHost(hostname)) {
      return 'http://localhost:3001'
    }
    return origin
  }

  if (process.env.NODE_ENV === 'production') {
    return PRODUCTION_API_URL
  }

  return 'http://localhost:3001'
}

export const getApiBase = () => {
  const base = resolveApiBaseUrl()
  if (!base) return '/api'
  return `${base}/api`
}

const API_BASE_URL = resolveApiBaseUrl()
const API_URL = getApiBase()

const TOKEN_KEY = 'proconnect_token'
const ADMIN_TOKEN_KEY = 'admin_token'
export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired'

export const AUTH_CREDENTIALS = { withCredentials: true }

/** @deprecated Cookie session is used; returns null. Kept for backward compatibility. */
export const getStoredAuthToken = () => null

export const getAuthHeaders = () => ({})

const notifySessionExpired = () => {
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT))
}

const handleUserSessionExpired = () => {
  localStorage.removeItem(TOKEN_KEY)
  notifySessionExpired()
  if (window.location.pathname.startsWith('/tableau-de-bord')) {
    window.location.href = '/connexion'
  }
}

const handleAdminSessionExpired = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem('admin_data')
  if (window.location.pathname.startsWith('/admin')) {
    window.location.href = '/admin-login'
  }
}

// Réponses non-enveloppées: chaque service lit lui-même { success, data, meta }.
export const apiClient = createApiClient({
  mode: 'cookie',
  baseURL: API_URL,
  unwrapEnvelope: false,
  onSessionExpired: handleUserSessionExpired,
})

export const adminApiClient = createApiClient({
  mode: 'cookie',
  baseURL: API_URL,
  unwrapEnvelope: false,
  onSessionExpired: handleAdminSessionExpired,
})

/** @deprecated Cookie session is used; no-op kept for backward compatibility. */
export const setAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

/** @deprecated Cookie session is used; no-op kept for backward compatibility. */
export const setAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
}

export const clearAllTokens = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem('admin_data')
}

export { API_BASE_URL, API_URL }
